import { render, staticRenderFns } from "./xs.vue?vue&type=template&id=d16f76f2&scoped=true&"
import script from "./xs.vue?vue&type=script&lang=js&"
export * from "./xs.vue?vue&type=script&lang=js&"
import style0 from "./xs.vue?vue&type=style&index=0&id=d16f76f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16f76f2",
  null
  
)

component.options.__file = "xs.vue"
export default component.exports